module.exports = __webpack_public_path__ + "static/media/Partner-LogosFloat.2a108c0d.png";